import React, { useEffect, useContext, useCallback } from "react";
import { convertirANumero } from "../../../helper/funciones";
import Label from "./LabelF";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { getAtributo } from "../../../context/FuncionesContext";
import axios from "axios";
import { farmageo_api } from "../../../../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FuncionesContext from "../../../context/FuncionesContext";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import InputRadio from "./InputRadio";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import FormControl from "@material-ui/core/FormControl";

export const SelectInput = (props) => {
  if (props.cab.enum_radio === "s") {
    return <InputRadio {...props} />;
  }

  return <SelectInputBase {...props} />;
};

const SelectInputBase = ({
  setValor,
  valor,
  cab,
  error,
  setError,
  data,
  valorFormulario,
  modoAlta,
  id_elemento,
}) => {
  const {
    id_a,
    nombre,
    opcionales_null,
    permite_null,
    margin_bottom_abm,
    width,
    select_es_maestro,
    // select_maestro_de,
    select_depende_de,
    select_info_adicional,
    select_info_adicional_campo,
    refrescarConfiguracion,
  } = cab;

  const { renderEnModal, refrescarConfiguracion: refrescarConfiguracionF } =
    useContext(FuncionesContext);

  const disabled = getAtributo("disabled", data, cab) === "s";
  const def = getAtributo("default", data, cab);

  const componerOpciones = () => {
    const value_null =
      data[cab.id_a + "_select_value_null"] ?? cab.select_value_null;
    const label_null =
      data[cab.id_a + "_select_label_null"] ?? cab.select_label_null;
    const opcion_null = {
      value: value_null ? value_null : null,
      label: label_null ? label_null : "Ninguno",
      disabled: disabled,
    };
    if (Array.isArray(cab.opciones)) return cab.opciones;
    if (data[cab.id_a + "_opciones"]) {
      const opciones_de_query_general = JSON.parse(
        data[cab.id_a + "_opciones"],
      );

      if (Array.isArray(opciones_de_query_general)) {
        if (value_null || label_null)
          opciones_de_query_general.push(opcion_null);
        return opciones_de_query_general;
      }
    }
    if (value_null || label_null) {
      return [opcion_null];
    }
    return [];
  };

  const [opciones, setOp] = React.useState(componerOpciones());
  const [opElegida, setOpElegida] = React.useState(
    opciones.find((op) => op.value === valor),
  );
  // console.log("SelectInput Render", { cab, valor, opciones, opElegida });
  const [loadingOptions, setLoadingOptions] = React.useState(false);

  const getOpciones = useCallback(
    async (ev) => {
      const body = {
        id_a,
        dependencias: {},
      };

      const select_depende_de_array = select_depende_de.split("|");
      for (const meastro_id_a of select_depende_de_array) {
        body.dependencias[meastro_id_a] = valorFormulario[meastro_id_a];
        if (ev?.detail?.[meastro_id_a]) {
          body.dependencias[meastro_id_a] = ev.detail[meastro_id_a];
        }
      }
      setLoadingOptions(true);
      await axios
        .post(farmageo_api + "/select/opcionesv2", body)
        .then((response) => {
          // console.log("response", response.data);
          const opValida = response.data?.find((op) => op.value === valor);
          setOp(response.data);
         // console.log("getOpciones")
          setValor(opValida?.value ?? "null");
        })
        .finally(() => {
          setLoadingOptions(false);
        });
    },
    [id_a, select_depende_de, valorFormulario, setValor, valor],
  );

  const style_input_abm = {
    width: width,
    marginBottom: margin_bottom_abm,
  };

  // useEffect Maestro
  useEffect(() => {
    if (valor || def) {
      if (valor && select_es_maestro === "s") {
        const SelectEvent = new CustomEvent(id_a + "_cambio", {
          detail: { [cab.id_a]: valor },
        });
        document.dispatchEvent(SelectEvent);
      }
      if (modoAlta) {
       // console.log("modoAlta")
        setValor(def);
        if (select_es_maestro === "s") {
          const SelectEvent = new CustomEvent(id_a + "_cambio", {
            detail: { [cab.id_a]: def },
          });
          document.dispatchEvent(SelectEvent);
        }
      }
    }
    if (select_depende_de) {
      const dependencias = select_depende_de.split("|");

      if (dependencias.some((dep) => !!valorFormulario[dep])) {
        //  Si el select depende de si mismo, no se hace nada
        getOpciones();
        return;
      }
    }
  }, [cab.default, setValor]);

  // useEffect Esclavo
  useEffect(() => {
    if (select_depende_de && select_depende_de !== "") {
      select_depende_de.split("|").forEach((meastro_id_a) => {
        if (meastro_id_a && meastro_id_a !== "") {
          document.addEventListener(meastro_id_a + "_cambio", getOpciones);
        }
      });
    }
    return () => {
      if (select_depende_de && select_depende_de !== "") {
        select_depende_de.split("|").forEach((meastro_id_a) => {
          if (meastro_id_a && meastro_id_a !== "") {
            document.removeEventListener(meastro_id_a + "_cambio", getOpciones);
          }
        });
      }
    };
  }, [getOpciones, id_a, select_depende_de, valorFormulario]);

  const handleChange = (e) => {
    const newOpElegida = opciones.find((op) => op.value === e.target.value);
   // console.log("handleChange")
    setValor(newOpElegida, cab.id_a);
    setOpElegida(newOpElegida);
    setError((e) => {
      const ne = { ...e };
      ne[id_a] = false;

      return ne;
    });

    if (select_es_maestro === "s") {
      const SelectEvent = new CustomEvent(id_a + "_cambio", {
        detail: { [cab.id_a]: e.target.value, newOpElegida },
      });
      document.dispatchEvent(SelectEvent);
    }
    if (refrescarConfiguracion && refrescarConfiguracion.trim() !== "") {
      refrescarConfiguracionF({ cab });
    }
  };

  return (
    <div style={style_input_abm}>
      <FormControl fullWidth>
        <Label
          label={nombre}
          opcionales_null={opcionales_null}
          permite_null={permite_null}
        />
        {cab.select_opcion_unica === "s" ? (
          <Default
            data={data}
            cab={cab}
            valor={opciones[0]?.label}
            id_elemento={id_elemento}
          />
        ) : (
          <Select
            id={id_elemento}
            style={{
              fontSize: "0.8rem",
              width: cab.width_input,
            }}
            // defaultValue={getAtributo("default", data, cab)}
            variant="outlined"
            size="small"
            onChange={handleChange}
            value={loadingOptions ? 1 : convertirANumero(valor)}
            error={error[id_a]}
            disabled={disabled}
          >
            {loadingOptions ? (
              <MenuItem value={1}>Cargando opciones ...</MenuItem>
            ) : (
              opciones &&
              opciones.map((opcion) => (
                <MenuItem
                  style={{
                    minWidth: "200px",
                    textAlign: "center",
                    fontSize: "0.8rem",
                  }}
                  value={convertirANumero(opcion.value)}
                  key={opcion.value + opcion.label}
                  disabled={opcion.disabled}
                >
                  {opcion.default ? <em>{opcion.label}</em> : opcion.label}
                </MenuItem>
              ))
            )}
          </Select>
        )}
        {select_info_adicional && opElegida && select_info_adicional_campo ? (
          <div
            style={{
              cursor: "pointer",
              fontSize: "1rem",
              marginLeft: "1rem",
              position: "absolute",
              top: "50%",
              left: "100%",
            }}
            onClick={() =>
              renderEnModal(opElegida[select_info_adicional_campo], {
                modal: "modal-viewportWidth80",
              })
            }
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </div>
        ) : (
          <></>
        )}
      </FormControl>
    </div>
  );
};

export default SelectInput;

function Default({ data, cab, hijos, id_elemento, valor }) {
  return (
    <>
      <div id={id_elemento} className="tarjeta_grid_item_label_item">
        <div
          className={data[cab.id_a + "_className"]}
          style={{ width: cab.width }}
        >
          <div style={{ textAlign: cab.align }}>{valor}</div>
        </div>
      </div>
      {hijos?.map((hijo) => hijo)}
    </>
  );
}
